/**
 * @generated SignedSource<<0c91b975b7d0c21d524bb7b4e7cb118f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UrlMappingDestinationModeType = "STATIC" | "TEMPLATE" | "%future added value";
export type UrlMappingMatchType = "EXACT" | "PREFIX" | "REGEX" | "HOST_PATH" | "TRANSFORM" | "%future added value";
export type UpdateUrlMappingInput = {
  clientMutationId?: string | null;
  urlMappingId: string;
  name?: string | null;
  matchType?: UrlMappingMatchType | null;
  priority?: number | null;
  sourceUrl?: string | null;
  sourceHost?: string | null;
  sourcePath?: string | null;
  regexPattern?: string | null;
  destinationUrl?: string | null;
  destinationMode?: UrlMappingDestinationModeType | null;
  conditions?: any | null;
  active?: boolean | null;
  startsAt?: string | null;
  endsAt?: string | null;
};
export type useUpdateUrlMappingActive_Mutation$variables = {
  input: UpdateUrlMappingInput;
};
export type useUpdateUrlMappingActive_MutationVariables = useUpdateUrlMappingActive_Mutation$variables;
export type useUpdateUrlMappingActive_Mutation$data = {
  readonly updateUrlMapping: {
    readonly urlMapping: {
      readonly id: string;
      readonly active: boolean;
    } | null;
  } | null;
};
export type useUpdateUrlMappingActive_MutationResponse = useUpdateUrlMappingActive_Mutation$data;
export type useUpdateUrlMappingActive_Mutation = {
  variables: useUpdateUrlMappingActive_MutationVariables;
  response: useUpdateUrlMappingActive_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUrlMappingPayload",
    "kind": "LinkedField",
    "name": "updateUrlMapping",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlMapping",
        "kind": "LinkedField",
        "name": "urlMapping",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateUrlMappingActive_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateUrlMappingActive_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de769e5f099007000c84761203aae310",
    "id": null,
    "metadata": {},
    "name": "useUpdateUrlMappingActive_Mutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateUrlMappingActive_Mutation(\n  $input: UpdateUrlMappingInput!\n) {\n  updateUrlMapping(input: $input) {\n    urlMapping {\n      id\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cad4c443d4fc5c9a924eabe748f64576";

export default node;
